import { ReactNode } from "react";

import { MessageDescriptor } from "react-intl";

export type CardType = "scrum" | "kanban" | "business";

export const CORE_PROJECT: "business" = "business";
export const SOFTWARE_PROJECT: "software" = "software";

export const JWM_TEMPLATE_PREFIX = "com.atlassian.jira-core-project-templates";

export const KANBAN_TEAM_MANAGED_KEY =
    "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
export const SCRUM_TEAM_MANAGED_KEY =
    "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
export const BLANK_TEMPLATE_TEAM_MANAGED_KEY = `${JWM_TEMPLATE_PREFIX}:jira-work-management-blank-project-team-managed`;
export const CAMPAIGN_MANAGEMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management";
export const CONTENT_MANAGEMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-core-simplified-content-management";
export const PROCESS_CONTROL_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed";
export const PROJECT_MANAGEMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed";
export const PROCUREMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-procurement-team-managed";
export const DESIGN_WEB_DESIGN_PROCESS_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process-team-managed";
export const HUMAN_RESOURCES_NEW_EMPLOYEE_ONBOARDING_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding-team-managed";
export const HUMAN_RESOURCES_RECRUITMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed";
export const LEGAL_IP_INFRINGEMENT_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-ip-infringement-team-managed";
export const FINANCE_BUDGET_CREATION_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-budget-creation-team-managed";
export const SALES_SALES_PIPELINE_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline-team-managed";
export const SALES_LEAD_TRACKING_KEY =
    "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed";
export const BUG_TRACKING_TEMPLATE_KEY =
    "com.pyxis.greenhopper.jira:gh-simplified-basic";

export const TemplateKeys = {
    KANBAN: KANBAN_TEAM_MANAGED_KEY,
    SCRUM: SCRUM_TEAM_MANAGED_KEY,
    BUSINESS: BLANK_TEMPLATE_TEAM_MANAGED_KEY,
    UNKNOWN: ""
} as const;

export const ProductKeys = {
    JSW: SOFTWARE_PROJECT,
    JWM: CORE_PROJECT
} as const;

export type TemplateKeysType =
    | (typeof TemplateKeys)[keyof typeof TemplateKeys]
    | "";
export type ProductKeysType = (typeof ProductKeys)[keyof typeof ProductKeys];
export type TemplateChoiceCategory = {
    name: ProductKeysType;
    displayName: MessageDescriptor;
    logoComponent: ReactNode;
    templateKeys: TemplateKeysType[];
};

export type TemplateChoiceStaticContent = {
    key: TemplateKeysType;
    title: MessageDescriptor;
    cardType: CardType;
    iconSrc: string;
    iconBackground: string;
    summary: MessageDescriptor;
    description: MessageDescriptor;
    status?: MessageDescriptor;
};

// JSMGROWTH-220 JSM_JPD_WAC_SIGNUP_KEY
export const PRODUCT_ROADMAP_KEY = "jira.polaris:roadmap";
export const CUSTOMER_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-external-service-desk";
export const HR_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-hr-service-desk";
export const LEGAL_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-legal-service-desk";
export const FINANCE_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-finance-service-desk";
export const ANALYTICS_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-analytics-service-desk";
export const IT_SERVICE_MANAGEMENT_KEY =
    "com.atlassian.servicedesk:simplified-it-service-management";

export const JSMGRWOTH_220_JSM_JPD_WAC_SIGNUP_KEYS = [
    PRODUCT_ROADMAP_KEY,
    CUSTOMER_SERVICE_MANAGEMENT_KEY,
    HR_SERVICE_MANAGEMENT_KEY,
    LEGAL_SERVICE_MANAGEMENT_KEY,
    FINANCE_SERVICE_MANAGEMENT_KEY,
    ANALYTICS_SERVICE_MANAGEMENT_KEY,
    IT_SERVICE_MANAGEMENT_KEY
] as const;
